export default __webpack_public_path__ + "static/cp-app-screens-next-fe31b820f74119ec7332447838ea0101.jpg";